import { z } from 'zod';

export const formSchema = z.object({
  nombre: z.string().min(3, 'El nombre debe tener al menos 3 caracteres',),
  id_cp: z.string().min(1, 'La categoría es obligatoria'),
  descripcion: z.string().min(1, 'La descripción es obligatoria'),
  precio: z.string().min(1, 'El precio es obligatorio'),
  sucursalesPlatillo: z.object({
    value: z.string().min(1),
    label: z.string().min(1),
  }, { required_error: 'La sucursal es obligatoria' }),
  /* tiempo: z.string().min(1, 'El tiempo es obligatorio'),
  multiImagenes: z.array(z.object({
    nombre: z.string()
  })).nonempty('Debes tener al menos una imagen'), */
  /* sucursalesPlatillo: z.array(z.object({
    label: z.string()
  })).nonempty('Debes tener al menos una sucursal') */
});
